export enum ClassEnum {
  Senior = 1,
  SubordinadaMezanino = 2,
  SubordinadaJunior = 3,
  NaoAplicavel = 4,
}
